import { Component, OnInit } from '@angular/core';
import { ReportPageBase } from 'src/shared/Baseclasses/report-page-base';
import { Constants } from 'src/shared/utilities/constants.util';
import { ReportService } from 'src/shared/services/report.service';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { ReportConstants } from '../../shared/report-constants.util';

@Component({
  selector: 'total-uos-trends-report-page',
  templateUrl: './total-uos-trends-report-page.component.html',
  styleUrls: ['./total-uos-trends-report-page.component.scss']
})

export class TotalUosTrendsPageComponent extends ReportPageBase implements OnInit 
{
  defaultFilters: ReportFilters = new ReportFilters();
  views:string[];
  defaultView:string;

  constructor(private reportService: ReportService){
    super();
  }
  
  ngOnInit()
  {
    this.filters = this.defaultFilters;
    this.views = [
        ReportConstants.DateViewLabel,
        ReportConstants.DayOfWeekViewLabel,
        ReportConstants.PeriodEndViewLabel,
        ReportConstants.ShiftBlockViewLabel,
        ReportConstants.WeekViewLabel
    ];
    this.defaultView = ReportConstants.DateViewLabel;
    this.reportService.announceSummarySelected(Constants.TotalUosSummary);
  }

  filterUpdated(filters:ReportFilters){
    this.filters = filters;
    this.filterEventsSubject.next();
  }
}
